import useScript from 'react-script-hook';

export type ScriptStateType = { loading: boolean; error: ErrorEvent | null };
type UseVideoTutorialType = {
    mainScript: ScriptStateType;
    video: ScriptStateType;
    videoClassName: string;
};

const useVideoTutorial = (videoHash: string, shwoThumbnail = false): UseVideoTutorialType => {
    const [mainScriptLoading, mainScriptError] = useScript({
        src: 'https://fast.wistia.com/assets/external/E-v1.js',
        checkForExisting: true,
    });

    const [videoLoading, videoError] = useScript({
        src: `https://fast.wistia.com/embed/medias/${videoHash}.jsonp`,
        checkForExisting: true,
    });
    const videoClassName = `
        wistia_embed 
        wistia_async_${videoHash}
        popover=true
        popoverAnimateThumbnail=true
        ${!shwoThumbnail ? 'popoverContent=link' : ''}
    `;

    return {
        mainScript: { loading: mainScriptLoading, error: mainScriptError },
        video: { loading: videoLoading, error: videoError },
        videoClassName,
    };
};

export default useVideoTutorial;
